<template>
  <div>
    <div class="form">
      <div class="logo">
        <img alt="logo" src="@/assets/images/logo.png" />
        <span>石上良品</span>
      </div>
      <a-form :form="form">
        <a-form-item name="phoneNumber">
          <a-input
            @keyup.enter.native="handleLogin"
            placeholder="手机号"
            v-decorator="['phoneNumber', { rules: [{ required: true, pattern: /^1\d{10}$/, message: '请输入正确的手机号' }] }]"
          />
        </a-form-item>
        <a-form-item name="password">
          <a-input
            @keyup.enter.native="handleLogin"
            placeholder="密码"
            type="password"
            v-decorator="['password', { rules: [{ required: true, message: '请输入密码' }] }]"
          />
        </a-form-item>
        <a-row>
          <a-button type="primary" @click="handleLogin">
            登录
          </a-button>
        </a-row>
      </a-form>
    </div>
    <div class="footer">
      <div class="copyright">
        石上良品  ©2022
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Login',

  data () {
    return {
      form: this.$form.createForm(this, { name: 'Login' })
    }
  },

  mounted () {
    if (this.$store.state.token) return this.$router.replace(this.$store.state.currentPath)
  },

  methods: {
    // 登录
    handleLogin () {
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }

        this.api.login(values).then(res => {
          if (res.code !== 0) {
            this.$message.error(res.msg)
          }
          this.$store.commit('setToken', res.data)

          // 获取管理信息，包含权限
          this.api.getManagerInfo().then(res2 => {
            const managerInfo = res2.data.getManagerInfo
            if (!managerInfo) return this.$message.error('登录失败：获取信息失败')
            this.$store.commit('setManagerInfo', managerInfo)
            this.$router.replace(this.$store.state.currentPath)
          })
        })
      })
    }
  }
}
</script>

<style scoped>
.form {
  position: absolute;
  top: 45%;
  left: 50%;
  margin: -160px 0 0 -160px;
  width: 320px;
  height: 280px;
  padding: 36px;
  box-shadow: 0 0 100px rgba(0,0,0,0.08);
}
.form button {
  width: 100%;
}
.form p {
  color: #cccccc;
  text-align: center;
  margin-top: 16px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}
.logo {
  text-align: center;
  cursor: pointer;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo img {
  width: 40px;
  margin-right: 12px;
  box-shadow: 0 0 10px 1px rgba(0,0,0,0.1);
  border-radius: 50%;
}
.logo span {
  vertical-align: text-bottom;
  font-size: 16px;
  text-transform: uppercase;
  display: inline-block;
  font-weight: 700;
  color: #1890ff;
}
.ant-spin-container, .ant-spin-nested-loading {
  height: 100%;
}
.footer {
  position: absolute;
  width: 100%;
  bottom: 0;
}
.copyright {
  margin: 48px 0 24px 0;
  padding: 0 16px;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
}

</style>
